/**
 * @fileoverview CTA event tracking for the landing page.
 *
 * Pushes straight to the Attend GA4 tag mounted by `GlobalAnalyticsHeader`. The landing
 * runs outside the provider tree on purpose, so it must not reach for the team-scoped
 * analytics helpers in `src/shared/analytics`.
 */
type TGtagWindow = Window & { gtag?: (...args: unknown[]) => void };

export function trackLandingCta(cta: string): void {
  if (typeof window === 'undefined') return;
  (window as TGtagWindow).gtag?.('event', 'cta_click', { cta, page: 'flex_landing' });
}
